<template>
  <div>
    <b-row align-h="center">
      <b-col sm="12" md="6" lg="4" class="text-center">
        <Auth source="cws" :service="service" />
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col sm="12" md="12" lg="10" v-if="isAuthInCurrentRegion">
        <b-alert v-if="error && !showModal" show variant="danger">
          <span v-if="error.type">{{ error.type }}</span><span v-if="error.description"> / {{ error.description }}</span>
        </b-alert>
        <div>
          <!-- <div v-show="this.serviceParams.debug == 'y'"> -->
          <div>
            <br />
            <label for="object-input-with-list">{{
              $t("choose_product")
            }}</label>
            <v-select
              v-model="product"
              :options="products"
              label="name"
              code="id"
            ></v-select>
          </div>

          <b-breadcrumb v-if="serviceParams&&!serviceParams.code" :items="breadcrumbs"></b-breadcrumb>

          <div v-if="product">
            <br />
            <div v-if="!projectsLoading">
              <label for="object-input-with-list">{{
                $t("choose_object", {
                  product: this.product.name,
                  service: $t(`cws_${service}`),
                })
              }}</label>
              <v-select
                :disabled="loading"
                v-model="choosedObject"
                :options="objects"
                label="name"
                code="_id"
              >
              </v-select>

              <br>
              <b-alert v-if="!showModal && (syncError || success)" :show="dismissCountDown" :variant="syncError ? 'danger' : 'success'">
                <template v-if="syncError">
                  <span v-if="syncError.type">{{ syncError.type }}</span>
                  <span v-if="syncError.description"> / {{ syncError.description }}</span>
                </template>
                <template v-else-if="success">
                  <span v-if="success.type">{{ success.type }}</span>
                  <span v-if="success.description"> / {{ success.description }}</span>
                </template>
              </b-alert>
              <b-button
                v-if="choosedObject"
                :disabled="!extObjectTokens.length"
                @click="updateServersInToken()"
                block
                variant="outline-secondary"
                >{{ $t("sync_servers") }}
              </b-button>

              <div v-if="serviceParams&&serviceParams.code&&!loading">
                <br />
                <b-button
                  :disabled="!choosedObject"
                  @click="showModal = true"
                  block
                  variant="primary"
                  >{{ $t("link") }}</b-button
                >
              </div>
              <div v-else-if="serviceParams&&!serviceParams.code&&!loading">
                <br />
                <b-button
                  :disabled="!choosedObject"
                  @click="showModalAuth = true"
                  block
                  variant="primary"
                  >{{ $t("authorize") }}</b-button
                >
              </div>
            </div>
            <div v-else>
              <b-spinner type="grow" :label="$t('loading')"></b-spinner>
            </div>
          </div>
        </div>

        <br />
        <template v-if="extObjectTokens.length">
          <p class="">
            {{ $t("activated_devices_for") }} {{ $t(`cws_${service}`) }}
          </p>
          <b-table
            :busy="loading"
            :fields="extObjectTokenFields"
            striped
            hover
            :items="extObjectTokens"
            responsive="sm"
          >
            <template v-slot:cell(actions)="data">
              <div class="text-right">
                <!-- <b-button
                  @click="getTokenServers(data.item)"
                  size="sm"
                  variant="outline-info"
                  >{{ $t("get_servers") }}
                </b-button> -->

                <b-button
                  class="ml-2"
                  @click="getTokenInfo(data.item)"
                  size="sm"
                  variant="outline-success"
                  >{{ $t("get_token_info") }}
                </b-button>
                <b-button
                  class="ml-2"
                  @click="unlinkToken(data.item)"
                  size="sm"
                  variant="outline-secondary"
                  >{{ $t("unlink") }}
                </b-button>
              </div>
            </template>
          </b-table>
        </template>
        <b-alert
          show
          variant="default"
          v-if="!extObjectTokens.length && choosedObject && !loading"
        >
          <p>
            {{ $t("no_services_linked_to") }}
            <b>{{ choosedObject.name }}</b>
          </p>
          <hr />
          <p class="mb-0">{{ $t("go_to_available_services") }}</p>
        </b-alert>
      </b-col>
    </b-row>

    <b-modal
      v-if="choosedObject"
      hide-footer
      v-model="showModal"
      ref="link_service"
      :title="$t('link_modal_title')"
    >
      <b-form @submit="linkOAuth">
        <b-alert v-if="error" show variant="danger">{{
          error.description
        }}</b-alert>
        <b-form-group
          :label="$t('device_name')"
          label-for="device_name"
          :description="$t('device_name_desc')"
        >
          <b-form-input
            id="device_name"
            v-model="deviceParams.device_name"
            type="text"
            required
            :placeholder="$t('enter_device_name')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('custom_data')"
          label-for="custom_data"
          :description="$t('custom_data_desc')"
        >
          <b-form-textarea
            id="custom_data"
            v-model="deviceParams.custom_data"
            :placeholder="$t('enter_custom_data')"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <br />
        <b-button block type="submit" variant="primary">{{
          $t("link_modal_button", modalTitle)
        }}</b-button>
      </b-form>
    </b-modal>

    <b-modal
      v-if="choosedObject"
      hide-footer
      v-model="tokenIridiumServers"
      ref="token_iridium_service"
      :title="$t('servers_modal_title')"
    >
      <b-form @submit="updateServersInToken" v-if="choosedToken">
        <b-alert v-if="syncError" show variant="danger">{{
          syncError.description
        }}</b-alert>

          <b-form-group>
            <!-- <template #label>
              <b>{{$t('select_server')}}</b><br>
              <b-form-checkbox
                v-model="allSelectedServers"
                :indeterminate="indeterminateServers"
                aria-describedby="servers"
                aria-controls="servers"
                @change="toggleAll"
              >
                {{ allSelectedServers ? 'Un-select All' : 'Select All' }}
              </b-form-checkbox>
            </template> -->

            <template v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                id="servers"
                v-model="selectedServers"
                :options="choosedToken.servers.map(s=>({hwid: s.hwid, name: s.name +' '+ s.hwid}))"
                text-field="name"
                value-field="hwid"
                :aria-describedby="ariaDescribedby"
                name="servers"
                class="ml-4"
                aria-label="Selected iRidi servers"
                stacked
              ></b-form-checkbox-group>
              </template>
            </b-form-group>

        <br />
        <b-button block type="submit" variant="primary">{{
          $t("update_servers_for_token")
        }}</b-button>
      </b-form>
    </b-modal>

    <b-modal
      size="xl"
      v-if="choosedObject && tokenServiceInfo"
      hide-footer
      v-model="showTokenInfoModal"
      ref="token_info"
      :title="$t('token_info_modal_title')"
    >
      <div class="text-center my-3">
        <b-button @click="saveFile(true)" variant="primary">{{$t('download_driver')}}</b-button>
        <!-- <b-button class="ml-2" @click="saveFile(true)" variant="danger">test</b-button> -->
      </div>
      <b-form-group label="iRidi token" class="mb-0">
        <b-form-input :value="tokenServiceInfo.service_token"></b-form-input>
      </b-form-group>
      <br>
      <b-form-group v-if="tokenServiceInfo.devices" id="copy_wrapper" label="Devices structure" class="mb-0 mt-3">
        <json-viewer
          :value="tokenServiceInfo.devices"
          :expand-depth="8"
          copyable
          boxed
          sort
          @copied="tryCopyAgain"
        />
      </b-form-group>
    </b-modal>

    <b-modal
      v-if="choosedObject"
      hide-footer
      v-model="showModalAuth"
      ref="auth_service"
      :title="$t('auth_modal_title')"
    >
      <b-form @submit.prevent="authorize">
        <b-alert v-if="error" show variant="danger">{{
          error.description
        }}</b-alert>
        <div class="text-start my-3">
          <p v-html="$t('auth_modal_note')"></p>
        </div>
        <b-form-group
          :label="$t('client_id')"
          label-for="client_id"
          :description="$t('client_id_desc')"
        >
          <b-form-input
            id="client_id"
            v-model="clientId"
            type="text"
            required
            :placeholder="$t('enter_client_id')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :label="$t('client_secret')"
          label-for="client_secret"
          :description="$t('client_secret_desc')"
        >
          <b-form-input
            id="client_secret"
            v-model="clientSecret"
            type="text"
            required
            :placeholder="$t('enter_client_secret')"
          ></b-form-input>
        </b-form-group>
        <b-button block type="submit" variant="primary">{{
          $t("auth_modal_submit")
        }}</b-button>
      </b-form>
    </b-modal>
    <b-col v-if="loading" class="text-center mt-4">
      <b-spinner type="grow" :label="$t('loading')"></b-spinner>
    </b-col>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-alert */
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
import api from '../api'
import Auth from '../components/Auth.vue'
import helper from '../../helper'

const copyToClipboard = str => {
  const wrapper = window.document.getElementById('copy_wrapper')
  const el = window.document.createElement('textarea')
  el.value = str
  console.log('str copy', str)
  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  wrapper.appendChild(el)
  el.select()
  window.document.execCommand('copy')
  wrapper.removeChild(el)
}

// console.log('hosts', helper.hosts)

export default {
  components: {
    Auth,
    'v-select': vSelect,
  },
  data() {
    return {
      error: null,
      syncError: null,
      success: null,
      loading: false,
      projectsLoading: false,
      dismissCountDown: 0,
      dismissSecs: 5,
      service: null,
      objects: [],
      choosedObject: null,
      serviceParams: null,
      token: '',
      extObjectTokens: [],
      showModal: false,
      showModalAuth: false,
      clientId: null,
      clientSecret: null,
      deviceParams: {
        device_name: '',
        custom_data: '',
      },
      product: null,
      products: [
        // { name: 'i3knx', code: 'i3knx' },
        // { name: 'i3lite', code: 'i3lite' },
        { name: 'i3pro', code: 'i3pro_bx' },
      ],
      netatmo: {
        service: 'netatmo',
        scope: 'read_station read_smarther read_bubendorff read_thermostat write_thermostat read_magellan write_magellan write_smarther write_bubendorff',
        state: 'pijr4ipjfredfln5gd',
        redirect_uri: {
          i3pro: 'https://cws.iridi.com/services/oauth/i3pro/netatmo',
        },
      },
      showTokenInfoModal: false,
      tokenServiceInfo: null,
      tokenIridiumServers: false,
      choosedToken: null,
      selectedServers: [],
      allSelectedServers: false,
      indeterminateServers: false,
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: this.$t('available_connections_page'),
          to: '/services/oauth/available',
        },
        {
          text: this.$t('oauth_tokens_btn'),
          active: true,
        },

      ]
    },
    extObjectTokenFields() {
      return [
        {
          key: 'device_meta.device_name',
          label: this.$t('device'),
        },
        {
          key: 'createdAt',
          label: this.$t('created_at'),
        },
        {
          key: 'actions',
          label: '', // this.$t('actions'),
        },
      ]
    },
    modalTitle() {
      return {
        objectName: this.choosedObject ? this.choosedObject.name : '',
        service: this.$t(`cws_${this.service}`),
      }
    },
    productApiUrl() {
      return this.product && this.region
        ? `${this.region.hosts[this.product.code]}/api/front/protected`
        : null
    },
    region() {
      return this.$root.$data.state.choosedRegion
    },
    isAuthInCurrentRegion() {
      return (
        this.region
        && this.$root.$data.state.auth
        && this.$root.$data.state.auth.token
        && this.$root.$data.state.auth.expTokenJsTimestamp > Date.now()
      )
    },
  },
  watch: {
    showModal() {
      this.error = null
      this.success = null
    },
    showTokenInfoModal(val) {
      this.error = null
      this.success = null
      if (val === false) {
        this.tokenServiceInfo = null
      }
    },
    product: {
      deep: true,
      handler(val) {
        this.error = null
        this.success = null
        console.log('product is changed', val)
        this.choosedObject = null
        this.extObjectTokens = []
        if (this.isAuthInCurrentRegion) {
          this.getObjects()
        }
      },
    },
    isAuthInCurrentRegion(isSuccessAuth) {
      if (isSuccessAuth) {
        this.getObjects()
      }
    },
    choosedObject: {
      deep: true,
      handler(val) {
        this.clientId = val.client_id ?? ''
        this.clientSecret = val.client_secret ?? ''
        if (this.isAuthInCurrentRegion) {
          this.getTokens()
        }
      },
    },
    objects: {
      deep: true,
      handler(val) {
        if (val && this.serviceParams && this.serviceParams.state && this.serviceParams.code) {
          const finded = val.find(obj => obj.objectId === this.serviceParams.state)
          if (!finded) return

          this.choosedObject = finded
        }
      },
    },
  },
  methods: {
    saveFile(convert) {
      let data = JSON.parse(JSON.stringify(this.tokenServiceInfo))
      console.log('data before', data)
      data = JSON.stringify(data)

      if (convert === true) {
        if (this.service === 'ajax') {
          data = helper.jsonConverterAjax(data)
        } else if (this.service === 'yeelight') {
          data = helper.jsonConverterYeelight(data)
        } else if (this.service === 'yeelight_pro') {
          data = helper.jsonConverterYeelightPro(data)
        } else if (this.service === 'netatmo') {
          data = helper.jsonConverterNetatmo(data)
        } else {
          data = helper.jsonConverter({
            token: this.tokenServiceInfo.service_token,
            device_data: this.tokenServiceInfo.devices,
          })
        }
      }

      console.log('data after', data)
      const blob = new Blob([data], { type: 'text/plain' })
      const e = document.createEvent('MouseEvents')
      const a = document.createElement('a')
      a.download = 'driver.json'
      a.href = window.URL.createObjectURL(blob)
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':')
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      a.dispatchEvent(e)
    },
    tryCopyAgain() {
      copyToClipboard(JSON.stringify(this.tokenServiceInfo.devices, null, 2))
    },
    handleError(response, code) {
      if (code === 200) {
        this.error = response
      } else if (response && response.status !== 500) {
        this.error = response.data.error
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
    handleErrorBCWS(errorObject) {
      if (errorObject.error_details || errorObject.error) {
        if (errorObject.error_details && errorObject.error_details.error) {
          this.error = {
            type: this.$t(errorObject.error_details.error),
            description: this.$t(errorObject.error_details.error_description),
          }
        } else if (errorObject.error) {
          this.error = {
            type: this.$t(errorObject.error[0]),
            description: this.$t(errorObject.error[1]),
          }
        } else {
          this.error = {
            type: this.$t('server_error'),
            description: this.$t('try_again_later'),
          }
        }
      } else {
        this.error = {
          type: this.$t('server_error'),
          description: this.$t('try_again_later'),
        }
      }
    },
    async getObjects() {
      if (!this.productApiUrl) {
        console.log('productApiUrl undefinded')
        return
      }

      if (!this.product) {
        return
      }

      this.projectsLoading = true

      const hosts = helper.hosts.filter((r) => r.available)
      const uniq = {}

      // eslint-disable-next-line no-restricted-syntax
      for (const region of hosts) {
        try {
          const res = await api.withAuth.get(
            `${
              region.hosts[this.product.code]
            }/api/front/protected/user/objects`,
          )
          res.data.data.forEach((obj) => {
            uniq[`${obj.id}:${region.code}`] = {
              crossId: `${region.code}:${obj.id}`,
              client_id: obj.client_id,
              client_secret: obj.client_secret,
              objectId: obj.id,
              objectUid: obj._id,
              region: {
                name: region.name,
                code: region.code,
              },
              name:
                hosts.length > 1 ? `${obj.name} [${region.code}]` : obj.name,
              product: this.product,
            }
          })
        } catch ({ response }) {
          this.handleError(response)
        }
      }

      this.objects = Object.values(uniq)
      this.projectsLoading = false
    },
    async getTokens() {
      if (!this.choosedObject || !this.productApiUrl) {
        return
      }

      this.loading = true

      try {
        const res = await api.withAuth.get(
          `${this.productApiUrl}/user/object/${
            this.choosedObject.objectId
          }/cws/tokens${this.service ? `?service=${this.service}` : ''}`,
        )

        const data = res.data

        this.extObjectTokens = data.data.length
          ? data.data
            .filter((t) => t.active)
            .map((t) => {
              t.createdAt = t.created_at ? t.created_at : t.createdAt

              if (!t.device_meta) {
                t.device_meta = {
                  device_name: this.$t('device_name_not_used'),
                  custom_data: '',
                }
              }

              return t
            })
            .map((t) => {
              t.createdAt = t.createdAt
                ? new Date(t.createdAt).toLocaleString()
                : this.$t('created_undefined')

              return t
            })
          : []
      } catch ({ response }) {
        if (response.data) {
          this.handleErrorBCWS(response.data)
        } else {
          this.handleError()
        }
      } finally {
        this.loading = false
      }
    },
    async saveClientTokens() {
      if (!this.clientId || !this.clientSecret) {
        return false
      }

      const body = {
        client_id: this.clientId,
        client_secret: this.clientSecret,
      }

      const res = await api.withAuth.post(`${this.productApiUrl}/user/object/${this.choosedObject.objectId}/tokens/save`, {
        ...body,
      })

      if (!res.data) {
        return false
      }

      return true
    },
    clearClientTokens() {
      this.clientId = null
      this.clientSecret = null
    },
    linkOAuth(e) {
      e.preventDefault()
      console.log({ clientId: this.clientId, clientSecret: this.clientSecret })
      console.log({ choosedObject: this.choosedObject })
      if (!this.productApiUrl) {
        return
      }
      if (!this.service) {
        this.error = {
          type: this.$t('undefined_linked_service'),
        }
        return
      }
      this.error = null
      this.success = null
      this.loading = true
      this.showModal = false

      api.withAuth
        .post(`${this.productApiUrl}/user/services/${this.service}/oauth`, {
          oid: this.choosedObject.objectId,
          serviceParams: this.serviceParams,
          deviceParams: this.deviceParams,
          product: this.product,
          region: this.region,
          lang: this.$i18n.locale,
          scope: this.serviceParams.scope,
          code: this.serviceParams.code,
          clientId: this.clientId,
          clientSecret: this.clientSecret,
        })
        .then((res) => res.data)
        .then((res) => {
          if (res.error) {
            this.handleError(res.error, 200)
          }

          if (res.data && res.data.res_cws && res.data.res_cws.initial_structure) {
            if (res.data.res_cws.initial_structure.error) {
              console.log(res.data.res_cws.initial_structure.error)
            } else {
              const driverStruct = res.data.res_cws.initial_structure.data
              this.showTokenInfoModal = true
              this.tokenServiceInfo = driverStruct
            }

            this.getTokens()

            const query = { ...this.$route.query }
            delete query.code
            delete query.state
            this.$router.replace({ query })

            this.serviceParams.code = false
            this.serviceParams.state = false
            this.clearClientTokens()
          }
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleErrorBCWS(response.data)
          } else {
            this.handleError()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTokenServers(token) {
      if (!token) {
        this.error = {
          type: this.$t('undefined_token'),
        }
      }

      this.showModal = false
      this.showTokenInfoModal = false
      this.tokenIridiumServers = true
      this.choosedToken = token
      this.selectedServers = []
    },
    async updateServersInToken() {
      this.loading = true
      this.dismissCountDown = 0
      this.syncError = null
      this.success = null

      try {
        const res = await api.withAuth.post(
          `${this.productApiUrl}/user/services/${this.service}/sync_servers`,
          {
            oid: this.choosedObject.objectId,
            serviceParams: this.serviceParams,
            product: this.product,
            region: this.region,
            lang: this.$i18n.locale,
          },
        )

        const data = res.data

        if (data.error) {
          console.log(data.error)

          this.syncError = {
            type: this.$t('servers_sync_fail'),
          }
          this.dismissCountDown = this.dismissSecs
          return
        }

        if (data.data && data.data.res_cws) {
          await this.getTokens()

          this.success = {
            type: this.$t('servers_sync_success'),
          }
          this.dismissCountDown = this.dismissSecs
        }
      } catch ({ response }) {
        console.log(response.data)

        this.syncError = {
          type: this.$t('servers_sync_fail'),
        }
        this.dismissCountDown = this.dismissSecs
      } finally {
        this.loading = false
      }
    },
    getTokenInfo(token) {
      this.loading = true
      if (!token) {
        this.error = {
          type: this.$t('undefined_token'),
        }
      }

      const url = this.service === 'netatmo'
        ? `https://lgr.cws.iridi.com/api/initial_structure/${this.service}`
        : `https://cws.iridi.com/api/initial_structure/${this.service}`

      api.withAuth
        .post(
          url,
          {},
          { headers: { Authorization: `Bearer ${token.token}` } },
        )
        .then((res) => {
          if (res.data.initial_structure) {
            if (res.data.initial_structure.error) {
              console.log(res.data.initial_structure.error)
              this.error = {
                type: this.$t('server_error'),
                description: res.data.initial_structure.error,
              }
            } else {
              const driverStruct = res.data.initial_structure.data
              this.showModal = false
              this.showTokenInfoModal = true
              this.tokenServiceInfo = driverStruct
            }
          } else {
            this.error = {
              type: this.$t('server_error'),
              description: this.$t('empty_structure'),
            }
          }
        })
        .catch(({ response }) => {
          this.handleError(response)
        })
        .finally(() => {
          this.loading = false
        })
    },
    unlinkToken(token) {
      if (!this.productApiUrl) {
        return
      }
      if (!token) {
        this.error = {
          type: this.$t('undefined_token'),
        }
        return
      }

      const ok = () => {
        this.loading = true

        api.withAuth
          .post(`${this.productApiUrl}/user/services/${this.service}/unlink`, {
            token,
            oid: this.choosedObject.objectId,
            lang: this.$i18n.locale,
          })
          .then(() => {
            this.getTokens()
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleErrorBCWS(response.data)
            } else {
              this.handleError()
            }
          })
          .finally(() => {
            this.loading = false
          })
      }

      this.$confirm.show(this.$t('are_you_sure_to_unlink'), ok)

      // eslint-disable-next-line no-restricted-globals
      // if (confirm(this.$t('are_you_sure_to_unlink'), ok)) {
      //   ok()
      // }
    },
    async authorize() {
      const saved = await this.saveClientTokens()
      if (!saved) {
        return
      }

      window.location.href = `https://api.netatmo.com/oauth2/authorize?client_id=${this.clientId}&scope=${this.netatmo.scope}&state=${this.choosedObject.objectId}&redirect_uri=${this.netatmo.redirect_uri[this.product.name]}`
    },
  },
  mounted() {
    this.serviceParams = this.$route.query
    this.service = this.$route.params.externalService

    if (this.token) {
      this.getObjects()
    }

    if (this.$route.params.product) {
      this.product = this.products.find(
        (p) => p.name === this.$route.params.product,
      )
    } else {
      this.product = this.products[0]
    }

    // if (this.products.length === 1) {
    //   this.product = this.products[0]
    // }
  },
}
</script>
